@for (data of dataNote; track data; let i = $index) {
  <div class="notes pl-1 pr-1">
    <div class="notes-item">
      <div class="long-word-container" [innerHTML]="getSafeHtml(data?.note)"></div>
      @if (isNote) {
        <div class="dropdown">
          <div ngbDropdown [open]="false" [autoClose]="true" class="d-inline-block">
            <i data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="dropdownBasic1" dropdown-menu
              dropdown-menu-left show ngbDropdownToggle (click)="$event.stopPropagation();"
            class="dropdown-toggle fas fa-ellipsis-v "></i>
            <div class="dropdown-menu" ngbDropdownMenu="dropdownBasic1">
              <a class="dropdown-item icon-table" (click)="editNoteEmit.emit(data.id)">
                <i class="far fa-eye"></i>
                Ver
              </a>
              @if (dataUser && dataUser.id && dataUser.id == data.userid) {
                <a class="dropdown-item icon-table"
                  (click)="deleteNote(data.id)">
                  <i class="far fa-trash-alt"></i>
                  Eliminar
                </a>
              }
              @if (dataUser && dataUser.id && dataUser.id == data.userid) {
                <a class="dropdown-item icon-table"
                  (click)="editNote(data.id)">
                  <i class="far fa-edit"></i>
                  Editar
                </a>
              }
            </div>
          </div>
        </div>
      }
      <div class="notes-footer d-flex justify-content-between align-items-end mt-1">
        <div class="notes-footer-left d-flex align-items-center">
          <div class="notes-due-date mr-5">
            <i class="far fa-clock font-size-small mr-1"></i>
            <span class="font-size-small">{{formatDate(data.date)}}</span>
          </div>
        </div>
        <div class="notes-footer-right">
          <div class="notes-users">
            <ul class="list-unstyled users-list cursor-pointer m-0 d-flex align-items-center">
              <li class="avatar pull-up my-0 " triggers="click" placement="left" [ngbTooltip]="data.name">
                <app-avatar-photo [photoUrl]="undefined" [name]="data.name"></app-avatar-photo>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
}
